const getters = {
    // 专业树结构列表
    // majorTreeList: (state, getters, rootState, rootGetters) => {
    majorTreeList: (state) => {
        const {majorTreeList} = state
        return majorTreeList || []
    },
    // 专业树结构列表(不包含没有子节点的数据)
    majorTreeHasChildrenList: (state, getters) => {
        const {majorTreeList} = getters
        if (!majorTreeList) {
            return []
        }
        return majorTreeList.filter(item => item.dictList && item.dictList.length > 0)
    },
}

export default getters
